<template>
    <div>
        <router-link to="/customer-contracts/new-contract" v-if=" $route.fullPath == '/customer-contracts'"  class="btn mt-4 float-right new_contract">New Contract</router-link>
        <br><br><br><br>
        <contract-table :contracts="contracts"></contract-table>
    </div>
</template>
<script>
    import contractTable from './table';
    export default {
        components: {
            contractTable,
        },
        computed:{
            contracts: function () {
                return this.$store.getters['termsandconditions/contracts'];
            },
        },
    }
</script>
<style scoped lang="scss">
.new_contract{
    border: 1px solid  rgb(72, 166, 166) !important;
    background: rgb(72, 166, 166) ;
    color: white;
    &:hover {
        background-color: #f0ed00;
        color: rgb(72, 166, 166) !important;
        background: white !important;
    }
}
</style>